import styled from 'styled-components';

export const VisitorsLayoutV2Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
`;
